import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import type { WorkspaceDataSource } from 'honeygrid-types'
import { Plus, Upload } from 'lucide-react'

interface DataSourcesTableProps {
	dataSources: WorkspaceDataSource[]
	onSelectDataSource: (ds: WorkspaceDataSource) => void
	onAddDataSource: () => void
	selectedDataSourceId?: string | number
}

export function DataSourcesTable({ dataSources, onSelectDataSource, onAddDataSource, selectedDataSourceId }: DataSourcesTableProps) {
	return (
		<Table>
			<TableHeader className="border-t border-t-[#3A2E2F]/20 border-b border-b-[#3A2E2F] [&_tr]:!border-0">
				<TableRow>
					<TableHead>Name</TableHead>
					<TableHead>Type</TableHead>
					<TableHead>Status</TableHead>
					<TableHead>Updated</TableHead>
				</TableRow>
			</TableHeader>
			<TableBody className="[&_tr:last-child]:!border-b [&_tr]:!border-0">
				{dataSources.length === 0 ? (
					<TableRow className="!border-b !border-b-[#3A2E2F]/20">
						<TableCell colSpan={4} className="h-32 p-0">
							<div className="flex flex-col items-center justify-center text-center space-y-3 bg-[#3A2E2F]/5 h-full py-8">
								<Upload className="h-8 w-8 text-foreground/60" />
								<p className="text-sm font-medium text-muted-foreground">No data sources yet</p>
								<Button variant="outline" size="sm" onClick={onAddDataSource}>
									<Plus className="h-4 w-4 mr-2" />
									Add Data Source
								</Button>
							</div>
						</TableCell>
					</TableRow>
				) : (
					dataSources.map((ds) => (
						<TableRow
							key={ds.id}
							className={`group cursor-pointer hover:bg-muted/50 !border-b !border-b-[#3A2E2F]/20 ${
								selectedDataSourceId === ds.id ? 'bg-muted' : ''
							}`}
							onClick={() => onSelectDataSource(ds)}
						>
							<TableCell className="font-medium">{ds.name}</TableCell>
							<TableCell className="capitalize">{ds.type}</TableCell>
							<TableCell>
								<Badge variant={ds.status === 'ready' ? 'default' : ds.status === 'processing' ? 'secondary' : 'secondary'} className="capitalize">
									{ds.status.replace('_', ' ')}
								</Badge>
							</TableCell>
							<TableCell className="text-sm text-muted-foreground">
								{ds.updated_at ? new Date(ds.updated_at).toLocaleString() : 'N/A'}
							</TableCell>
						</TableRow>
					))
				)}
			</TableBody>
		</Table>
	)
}


